import Color from 'color';
import { lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';
import { borderColor2 } from 'pages/styles';
import styled from 'styled-components';

const inkStrong = '#212529';
const inkMuted = '#6c757d';
const inkFaint = '#8a939c';
const accent = '#3d5a80';

export const Anchor = styled.div<{ $flush?: boolean }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: ${({ $flush }) => ($flush ? '0' : '4px')};
`;

/** Line-style trigger — no bordered block chrome. */
export const LineTrigger = styled.button<{ $open?: boolean; $line?: boolean }>`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  max-width: 100%;
  min-height: ${({ $line }) => ($line ? '20px' : '24px')};
  padding: ${({ $line }) => ($line ? '1px 2px' : '2px 4px')};
  border: none;
  border-radius: 4px;
  background: ${({ $open }) => (
    $open ? Color(lFColor0).alpha(0.12).toString() : 'transparent'
  )};
  color: ${({ $open }) => ($open ? lFColor0 : inkStrong)};
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  font-family: inherit;
  cursor: pointer;
  line-height: 1.2;
  transition: background 120ms ease, color 120ms ease;

  &:hover {
    background: ${Color(lFColor0).alpha(0.1).toString()};
    color: ${lFColor0};
  }

  & > svg {
    font-size: 15px;
  }
`;

export const TriggerLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TriggerCaret = styled.span<{ $open?: boolean }>`
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  border-left: 3.5px solid transparent;
  border-right: 3.5px solid transparent;
  border-top: 4.5px solid currentColor;
  opacity: 0.7;
  transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'none')};
  transition: transform 120ms ease;
`;

export const Popup = styled.div`
  position: fixed;
  z-index: 1400;
  width: min(248px, calc(100vw - 24px));
  padding: 8px;
  background: white;
  border: 1px solid ${Color(borderColor2).lighten(0.05).toString()};
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14), 0 0 0 1px rgba(0, 0, 0, 0.04);
`;

export const SectionLabel = styled.div`
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${inkFaint};
  margin: 2px 6px 6px;
`;

export const DisabledHint = styled.p`
  margin: 0 6px 4px;
  font-size: 12.5px;
  font-weight: 500;
  line-height: 1.4;
  color: ${inkStrong};
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const OptionRow = styled.button<{ $checked?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  text-align: left;
  border: none;
  border-radius: 6px;
  padding: 8px;
  background: ${({ $checked }) => (
    $checked ? Color(accent).alpha(0.1).toString() : 'transparent'
  )};
  color: ${inkStrong};
  cursor: pointer;
  font-family: inherit;
  transition: background 100ms ease;

  &:hover {
    background: ${({ $checked }) => (
    $checked
      ? Color(accent).alpha(0.14).toString()
      : 'rgba(0, 0, 0, 0.035)'
  )};
  }
`;

export const OptionIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  margin-top: 1px;
  color: ${inkMuted};

  & > svg {
    font-size: 18px;
  }
`;

export const OptionText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const OptionTitle = styled.span`
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.25;
`;

export const OptionHint = styled.span`
  font-size: 11px;
  font-weight: 400;
  color: ${inkMuted};
  line-height: 1.3;
`;

export const OptionCheck = styled.span<{ $checked?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-top: 1px;
  border-radius: 50%;
  border: 1.5px solid ${({ $checked }) => (
    $checked ? accent : Color(borderColor2).darken(0.05).toString()
  )};
  background: ${({ $checked }) => ($checked ? accent : 'white')};
  color: white;

  & > svg {
    font-size: 12px;
  }
`;
